/** Skip duplicate in-flight or already-succeeded keyed report fetches. */
export function skipIfFetchKeyLoaded(slice, key) {
  if (!key) return false
  const k = String(key)
  if (slice.status === "loading" && String(slice.requestedFetchKey ?? "") === k) {
    return true
  }
  if (slice.status === "succeeded" && String(slice.fetchedFetchKey ?? "") === k) {
    return true
  }
  return false
}

/** Skip duplicate client-scoped fetches (e.g. client metric goals). */
export function skipIfClientLoaded(slice, clientId) {
  const id = clientId != null ? String(clientId) : ""
  if (!id) return false
  if (slice.status === "loading" && String(slice.requestedClientId ?? "") === id) {
    return true
  }
  if (slice.status === "succeeded" && String(slice.fetchedClientId ?? "") === id) {
    return true
  }
  return false
}

/** Skip duplicate in-flight or already-succeeded keyed pulse daily-status fetches. */
export function skipIfPulseFetchKeyLoaded(slice, key) {
  if (!key) return false
  const k = String(key)
  if (slice.pulseStatus === "loading" && String(slice.pulseRequestedFetchKey ?? "") === k) {
    return true
  }
  if (slice.pulseStatus === "succeeded" && String(slice.pulseFetchedFetchKey ?? "") === k) {
    return true
  }
  return false
}

/** Skip pulse APIs when client + previousDate already loaded. */
export function skipIfPulseLoaded(slice, clientId, previousDate) {
  const id = clientId != null ? String(clientId) : ""
  const prev = previousDate != null ? String(previousDate) : ""
  if (!id) return false
  if (slice.status === "loading" && String(slice.requestedClientId ?? "") === id) {
    return true
  }
  if (
    slice.status === "succeeded" &&
    String(slice.fetchedClientId ?? "") === id &&
    String(slice.previousDate ?? "") === prev
  ) {
    return true
  }
  return false
}

/** Skip static catalog GETs (social network types, metric goals catalog). */
export function skipIfCatalogLoaded(slice) {
  if (slice.status === "loading") return true
  if (slice.status === "succeeded") return true
  return false
}
